var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"small":"","color":"primary","disabled":_vm.disabled,"outlined":""},on:{"click":_vm.checkReservationQueueBulk}},[_vm._v("Try to reserve")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }